// Module
var code = "<template class=\"${name == tabNav.value ? '--active' : ''} ${disabled ? '--disabled' : ''} ${invalid ? '--invalid' : ''}\" inert.bind=\"disabled\"> <require from=\"./tab.scss\"></require> <button appearance=\"none\" click.delegate=\"onClick()\"> <slot></slot> </button> </template> ";
// Exports
module.exports = code;